module.exports = __webpack_public_path__ + "96da26a84168d90bf076de67801fb5b5.svg";